import { Amplify } from 'aws-amplify';

// OAuth configuration
const oauthConfig = process.env.REACT_APP_COGNITO_DOMAIN ? {
  domain: process.env.REACT_APP_COGNITO_DOMAIN,
  scopes: ['openid', 'email', 'profile'],
  redirectSignIn: [window.location.origin],
  redirectSignOut: [window.location.origin],
  responseType: 'code' as const
} : undefined;

const awsConfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_AWS_REGION || 'eu-central-1',
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID!,
      loginWith: {
        username: true,
        ...(oauthConfig && { oauth: oauthConfig })
      }
    }
  }
};

// Configure Amplify
Amplify.configure(awsConfig);

export default awsConfig;